import { IStorageAdapter } from './adapter.interface';

export class StorageAdapter implements IStorageAdapter<unknown> {
    private readonly storage: Storage;
    constructor(storage: Storage = localStorage) {
        this.storage = storage;
    }
    getAll = () =>
        Array.from({ length: this.storage.length || 0 }).reduce((o: object, _, index) => {
            const key = this.storage.key(index);
            return { ...o, [key]: this.get(key) };
        }, {}) as { [key: string]: unknown };

    get = <T>(key: string): T | string | null => {
        const value = this.storage.getItem(key);

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    };

    set = (key: string, value: unknown): void => {
        const item = typeof value === 'string' ? value : JSON.stringify(value);
        this.storage.setItem(key, item);
    };

    has = (key: string): boolean => !!this.storage.getItem(key);

    clear = (): void => this.storage.clear();

    delete = (key: string): void => this.storage.removeItem(key);
}
